import axios from "axios"
import { RegistrarLogErro } from "./clientefiel"

// const url = "http://localhost:3001/api"
const url = "https://zexnxuvx43.execute-api.us-east-1.amazonaws.com/api"

const apiLambdaLocal = axios.create({
    baseURL: url,
})

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = data => {
    try {
        console.log("ErroRequisicao> ", data.request, data.message)

        if (data.message === "Network Error") {
            return "Verifique sua conexão!"
        }

        if (data.request && data.request.responseText) {
            const resposta = JSON.parse(data.request.responseText)
            return resposta.mensagem || "Erro desconhecido!"
        }

        return "Erro inesperado na requisição!"
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
        return "Erro ao tratar requisição!"
    }
}

export const buscarConfiguracoesImpressora = async autorizacao => {
    const url = `/configuracoes-impressora/buscar`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaLocal.get(url, { headers: headers })
        return tratamentoResponse(response, "buscarConfiguracoesImpressora")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "buscarConfiguracoesImpressora")
        return { retornoErro: 1, mensagem: erro }
    }
}

export const atualizarConfiguracoesImpressora = async (data, autorizacao) => {
    const url = `/configuracoes-impressora/atualizar`
    const headers = {
        "Content-Type": "application/json",
        Authorization: autorizacao,
    }

    try {
        const response = await apiLambdaLocal.post(url, data, { headers: headers })
        return tratamentoResponse(response, "atualizarConfiguracoesImpressora")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "atualizarConfiguracoesImpressora")
        return { retornoErro: 1, mensagem: erro }
    }
}
